if (!customElements.get('variant-specifications')) {
  customElements.define(
    'variant-specifications',
    class VariantSpecifications extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('[data-variant-specs-select]');
        this.panels = this.querySelectorAll('[data-variant-specs-panel]');
        if (!this.select || !this.panels.length) return;

        this.select.addEventListener('change', () => {
          this.showVariant(this.select.value);
        });

        this.syncWithVariantSelector();
      }

      showVariant(variantId) {
        const id = String(variantId);
        let matched = false;

        this.panels.forEach((panel) => {
          const isMatch = panel.getAttribute('data-variant-specs-panel') === id;
          panel.hidden = !isMatch;
          if (isMatch) matched = true;
        });

        if (matched && this.select.value !== id) {
          this.select.value = id;
        }
      }

      syncWithVariantSelector() {
        const sectionId = this.getAttribute('data-section');
        const selector =
          document.querySelector(`variant-radios[data-section="${sectionId}"]`) ||
          document.querySelector(`variant-selects[data-section="${sectionId}"]`);
        if (!selector) return;

        const form = document.getElementById(this.getAttribute('data-product-form-id'));
        const variantInput = form ? form.querySelector('input[name="id"]') : null;
        if (!variantInput) return;

        selector.addEventListener('change', () => {
          window.requestAnimationFrame(() => {
            if (variantInput.value) this.showVariant(variantInput.value);
          });
        });
      }
    }
  );
}
